
import  './scrollToTop.scss';

function ScrollToTop() {
    let o=document.getElementById("scrollToTop");
    window.onscroll=function() {
         let o=document.getElementById("scrollToTop");
        window.scrollY>document.documentElement.clientHeight?o.style.opacity="1":o.style.opacity="0"
    };
        document.addEventListener("click",t=>{
            if(t.target.classList.contains("scrollToTop"))
            {t=Math.max(document.body.scrollTop,document.documentElement.scrollTop);
                if (0<t) {
                    window.scrollBy(0,-t);
                    o=setTimeout("",2)
                }
                else {
                    clearTimeout(o)
                }
            }
        });
    return (
    <div  className='scrollToTop' id="scrollToTop"></div>
    )
}
export default ScrollToTop;